module.exports = __webpack_public_path__ + "img/case8-京.4fd30db9.png";